<template>
  <div>
    <a-table
      ref="table"
      size="middle"
      :scroll="{x:true}"
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="false"
      :loading="loading"
      class="j-table-force-nowrap">

      <template slot="statusSlot" slot-scope="text, record">
        <span>{{getStatus(record)}}</span>
      </template>
    </a-table>
  </div>
</template>

<script>
  import {getAction, postAction} from '@/api/manage'

  export default {
    name: 'BizInsuranceDataInvoiceForm.vue',
    props: {
      // 业绩id
      insuranceDataId: {
        type: String,
        default: '',
        required: true
      },
    },
    data() {
      return{
        description: '发票信息',
        dataSource: [],
        ipagination:{},
        loading: false,
        columns:[
          {
            title:'开票编号',
            align:"center",
            dataIndex: 'invoiceNumber'
          },
          {
            title:'开票日期',
            align:"center",
            dataIndex: 'invoiceTime',
          },
          {
            title:'发票状态',
            align:"center",
            scopedSlots: { customRender: 'statusSlot' }
          },
        ],
        url:{
          getInvoiceInfo:'bms/bizInsuranceData/getInvoiceByInsuranceId',
        },
      }
    },
    mounted(){
      this.loadData();
    },
    methods:{
      loadData(){
        if(this.insuranceDataId){
          this.loading = true
          getAction(this.url.getInvoiceInfo,{insuranceDataId:this.insuranceDataId})
            .then(res => {
            if(res.success){
              this.dataSource = res.result
              this.loading = false
            }
          })
        }
      },
      getStatus(record){
        // 发票状态 0 未推送 1已推送 2 已开票 3 已到账
        const INVOICE_STATUS_NOT_SEND = '0';
        const INVOICE_STATUS_SENT = '1';
        const INVOICE_STATUS_INVOICED = '2';
        const INVOICE_STATUS_PAYED = '3';

        if( record.status == INVOICE_STATUS_NOT_SEND){
          return "待推送"
        } else if(record.status == INVOICE_STATUS_SENT){
          return "已推送"
        } else if(record.status == INVOICE_STATUS_INVOICED){
          return "已开票"
        } else if(record.status == INVOICE_STATUS_PAYED){
          return "已到账"
        }
      },
    },
  }
</script>

<style scoped>

</style>